import { render, staticRenderFns } from "./MediumProductCard.vue?vue&type=template&id=21436ade&scoped=true&"
import script from "./MediumProductCard.vue?vue&type=script&lang=js&"
export * from "./MediumProductCard.vue?vue&type=script&lang=js&"
import style0 from "./MediumProductCard.vue?vue&type=style&index=0&id=21436ade&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21436ade",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppImage: require('/vercel/path0/components/general/AppImage.vue').default,BookOpen: require('/vercel/path0/components/icons/BookOpen.vue').default,ArrowLeft: require('/vercel/path0/components/icons/ArrowLeft.vue').default,AppLink: require('/vercel/path0/components/general/AppLink.vue').default})
